/** @jsxImportSource theme-ui */
import React from 'react';

import { valignHackTop } from 'utils/cssHelpers';

import { BdIcon } from 'components/_common/BdIcon';

type BdCaseIncidenceInheritedIconProps = {
  valignTop?: string;
};
const BdCaseIncidenceInheritedIcon: React.FC<BdCaseIncidenceInheritedIconProps> = ({
  valignTop = '-8px',
}) => {
  const isInheritedIconStyle = {
    fontSize: '6px',
    width: '6px',
    ...valignHackTop(valignTop),
  };

  return (
    <BdIcon
      data-testid="is-inherited-icon"
      sx={{ '&.icon.bd-icon.asterisk-icon': isInheritedIconStyle }}
      name="icon-asterisk"
      color="sunflower100"
      className="asterisk-icon"
    />
  );
};

export default BdCaseIncidenceInheritedIcon;
